const SLOT_BLOCK_REASON = {
  CLOSED: "closedUid",
  BOOKING_DURATION_LIMIT: "bookingDurationLimitUid",
  PAX_LIMIT: "PaxLimitUid",
  toString(type) {
    switch (type) {
      case this.CLOSED:
        return "Restaurant is closed";
      case this.BOOKING_DURATION_LIMIT:
        return "This slot exceeds the default booking duration";
      case this.PAX_LIMIT:
        return "This slot reached the pax limit";
      default:
        return "";
    }
  },
};

const BOOKING_TYPE = {
  RESERVATION: "reservation",
  WAITLIST: "waitlist",
  WALK_IN: "walk-in",
  WALK_IN_HISTORY: "walk-in-history",
  WAITLIST_HISTORY: "waitlist-history",
};

const CUSTOMER_STATUS = {
  PENDING: "pendingUid",
  BOOKED: "unconfirmedUid",
  DELAYED: "delayedUid",
  CONFIRMED: "confirmedUid",
  CANCELLED: "cancelledUid",
  DELETED: "deletedUid",
  PARTIALLY_SEATED: "partiallySeatedUid",
  SEATED: "seatedUid",
  COMPLETED: "completedUid",
  REMOVED: "removedUid",
  toString(status) {
    switch (status) {
      case this.CONFIRMED:
        return "Customer Confirmed";
      case this.CANCELLED:
        return "Customer Cancelled";
      case this.DELAYED:
        return "Delayed";
      case this.PENDING:
        return "Pending";
      case this.BOOKED:
        return "Booked";
      case this.DELETED:
        return "No-Show";
      case this.PARTIALLY_SEATED:
        return "Partially Seated";
      case this.SEATED:
        return "Seated";
      case this.COMPLETED:
        return "Completed";
      case this.REMOVED:
        return "Removed";
      default:
        return "";
    }
  },
};

module.exports = {
  SLOT_BLOCK_REASON,
  BOOKING_TYPE,
  CUSTOMER_STATUS,
};
